module.exports = __webpack_public_path__ + "img/step-13.12a84d29.jpg";